import React from 'react';

import { Route } from 'src/components/Router/Route';
import { useTypedSelector } from 'src/modules/hooks/useTypedSelector';
import type { Card } from 'src/types';

import { getComponent } from './loadingCards';

interface LoadingProps {
  card: Card;
}

export const Loading = ({ card }: LoadingProps) => {
  const page = useTypedSelector((state) => state.router.page);

  return (
    <>
      <Route card={card} component={getComponent({ card, page })} />
    </>
  );
};
